import { axios } from '../../services/axios';

export default async function getGCCHLoginLink(
    companyId,
    location = window.location.href,
) {
    return axios
        .get(`/company/${companyId}/MSGCCHLoginLink?domain=${location}`)
        .then((res) => res)
        .catch((e) => e);
}
